// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + ({"2579": "admin-app","2580": "bc-driver-tour","2581": "driver-tour","2590": "matm-app","2591": "matm-chats",}[chunkId] || chunkId) + ".css"
}